export class SubHeaderRow {
	constructor(public Name: string) { }
}